import { VivaEngageAppEntityId } from 'teams/context';

import { useGetEntityId } from './selectors';

type UseIsVivaEngageEntity = () => boolean;
export const useIsVivaEngageEntity: UseIsVivaEngageEntity = () => {
  const isVivaEngageEntity = useGetEntityId() === VivaEngageAppEntityId;
  const shouldEmulateVivaEngage = (process.env.EMULATE_VIVA_ENGAGE as unknown) === true;

  return isVivaEngageEntity || shouldEmulateVivaEngage;
};
